module.exports = __webpack_public_path__ + "img/resultBg.80e81cc.png";